import { render } from "./CheckListsReports.vue?vue&type=template&id=2b42c980&scoped=true"
import script from "./CheckListsReports.vue?vue&type=script&lang=js"
export * from "./CheckListsReports.vue?vue&type=script&lang=js"

import "./CheckListsReports.vue?vue&type=style&index=0&id=2b42c980&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b42c980"]])

export default __exports__